<template>
  <v-dialog :value="true" persistent :max-width="maxWidth">
    <v-card>
      <v-card-title class="primary modal-title">
        <span>Confirmação de e-mail</span>
        <v-spacer/>
        <v-btn icon @click="fecharModal">
          <v-icon size="20" color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text style="overflow-x: hidden">
        <div class="box-modal-confirm">
          <div style="text-align: center">
            <span class="text-modal-confirm">É necessário realizar uma confirmação para efetivar a criação d{{tipoEscIpm}}.</span><br>
            <span class="text-modal-confirm">Enviamos um e-mail para <strong>{{endereco}}</strong>, por favor verifique o recebimento.</span>
          </div>
        </div>
      </v-card-text>
      <v-layout class="justify-center">
        <v-btn class="mr-3 mb-3 primary" @click.prevent="fecharModal">
          OK
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    name: 'ModalMensagemConfirmarEmail',
    props: {
        title: {
            type: String
        },
        tipo: {
            type: String,
        },
        endereco:{
            type: String,
        },
        maxWidth: {
            type: String,
            default: '650'
        }
    },
    methods: {
        fecharModal() {
            this.$emit('fechar')
        },
    },
    computed:{
        tipoEscIpm(){
            return this.tipo === 'ESCLARECIMENTO' ? 'o esclarecimento' : 'a impugnação'
        }
    }
}
</script>

<style lang="stylus" scoped>
.text-modal-confirm
  color #3A6861
  font-weight 550
  font-size 1.15em

.box-modal-confirm
  display flex
  flex-direction column
  justify-content center
  align-items center
  min-height 100px
</style>